import React, { useCallback, useEffect, useRef, useState } from "react";
import OtpInput from "react-otp-input";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { detectIncognito } from "detectincognitojs";
import Toast_Icon from "../../assets/toast-icon.svg";
import joshLogo from '../../assets/josh-logo.svg'
import socialGoogle from '../../assets/social-google.svg'
import socialFacebook from '../../assets/social-facebook.svg'
import socialApple from '../../assets/social-apple.svg'
import backImg from '../../assets/back-img.svg'
import CloseDarkBlack from "../../assets/close-dark-black.svg";
import Close_white from "../../assets/white-close.svg";
import aboutSlider1 from "../../assets/about-1.svg";
import aboutSlider2 from "../../assets/about-2.svg";
import aboutSlider3 from "../../assets/about-3.svg";
import aboutSlider4 from "../../assets/about-4.svg";
import leftCoin from "../../assets/left-coin.svg";
import rightCoin from "../../assets/right-coin.svg";
import aboutIocon1 from "../../assets/apple-about.svg";
import aboutIocon2 from "../../assets/google-about.svg";
import aboutIocon3 from "../../assets/facebook-about.svg";
import down_arrow_gray from "../../assets/down_arrow_gray.svg";
import { checkLoginApi, getAppProfileInfo, onSendOTP, onSendOTPVerify, onSocialVerify } from "../../services";
import { LoginSocialApple, LoginSocialFacebook, LoginSocialGoogle } from "reactjs-social-login";
import { encryptResponse, phoneNumberFormat } from "../../utils/common";
import { onJustReducerUpdate } from "../../redux/action";
import { PROFILE_DETAILS, REGISTER_DETAILS } from "../../redux/action_type";
import { jsonWithDialCode, jsonWithoutDialCode } from "../../constants/countryList";
import { useToast } from "../../toast";
import { GoogleLogin } from "@react-oauth/google";
import IsLoadingHOC from "../HOC/loader/IsLoadingHOC";
import FingerprintJS from '@fingerprintjs/fingerprintjs'

function Login({ setLoading }) {
    const [otp, setOtp] = useState("");
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [isError, setIsError] = useState(false);
    const [provider, setProvider] = useState(null)
    const [profile, setProfile] = useState(null)
    const [counter, setCounter] = useState(0);
    const [triggerOtp, setTriggerOtp] = useState(0);
    const [isResetEnable, setIsResetEnable] = useState(false);
    const [isOTPEnable, setIsOTPEnable] = useState(false);
    const [reSendClicked, setReSendClicked] = useState(false);
    const [search, setSearch] = useState("")
    const [otpFocus, setOtpFocus] = useState(false);
    const [incognito, setIncognito] = useState(false)
    const [incognitoMode, setIncognitoMode] = useState(false)
    const [deviceId, setDeviceId] = useState("")
    const myRef = useRef(null)
    const otpRef = useRef(null)
    const toast = useToast();
    const useQuery = () => {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    const [selectedCountry, setSelectedCountry] = useState({
        "name": "India",
        "code": "IN",
        "emoji": "🇮🇳",
        "unicode": "U+1F1EE U+1F1F3",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
        "dial_code": "+91"
    })
    const [countryList, setCountryList] = useState([])
    const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
    const OTP_LENGTH = 6
    const dispatch = useDispatch()
    const history = useHistory();
    const storageValue = localStorage.getItem("clientID")
    const client_id = JSON.parse(storageValue)?.client_id || ""
    const clientIDs = useSelector((state) => state.clientID || {})
    var auth2 = null
    let query = useQuery();

    const isRedirect = JSON.parse(localStorage.getItem("isActive", "false")) || false
    // useEffect(() => {
    //     window.gapi.load('auth2', function () {
    //         auth2 = window.gapi.auth2.init({
    //             client_id: process.env.REACT_APP_GG_APP_ID,
    //             cookiepolicy: 'single_host_origin',
    //             response_type: 'id_token permission',
    //             redirect_uri: REDIRECT_URI
    //         });
    //         attachSignin(document.getElementById('customBtn'));
    //         attachSignin(document.getElementById('googleBtn'));
    //     });
    // }, [clientIDs])

    useEffect(() => {
        detectIncognito().then((result) => {
            setIncognito(result?.isPrivate)
        })
        if (isRedirect) {
            // $("#aboutus-modal").modal("show");
            localStorage.removeItem("isActive")
        }

    }, [])


    useEffect(() => {
        checkLogin()
    }, [])

    const checkLogin = async () => {
        try {
            setLoading(true);
            const fpPromise = FingerprintJS.load()
            fpPromise
                .then(fp => fp.get())
                .then(result => {
                    const visitorId = result.visitorId
                    let payload = {
                        "device_id": visitorId
                    }
                    setDeviceId(visitorId)
                    detectIncognito().then((result) => {
                        checkLoginApi({ ...payload, is_incognito: result.isPrivate }).then(async (res) => {
                            setLoading(false);
                            setIncognitoMode(result.isPrivate)
                            if (res.status) {
                                setLoading(false)
                                dispatch(onJustReducerUpdate(res.data, REGISTER_DETAILS))
                                localStorage.setItem(REGISTER_DETAILS, JSON.stringify(res.data))
                                history.push("/dashboards");
                            }

                        }).catch((err) => setLoading(false))

                    }).catch((err) => setLoading(false));

                })
        } catch (error) {
            setLoading(false);
        }
    }

    const handleFocus = () => {
        myRef.current.focus()
    }

    function attachSignin(element) {
        auth2.attachClickHandler(element, {},
            function (googleUser) {
                const responseData = googleUser?.getAuthResponse()
                if (responseData) {
                    console.log("123googleUser", responseData)
                    onLoginResolve("GOOGLE", responseData?.id_token)
                }
            }, function (error) {
                console.log("123error", error, client_id || clientIDs?.client_id)
            });
    }

    useEffect(() => {
        const timer = setInterval(() => {
            if (counter === 0) {
                if (triggerOtp === 4) {
                    $(".otp-wrap").hide();
                    $(".login-wrap ").show();
                    setReSendClicked(false)
                    setIsResetEnable(false)
                    setTriggerOtp(0)
                }
                if (isOTPEnable) {
                    setIsResetEnable(true)
                    clearInterval(timer)
                }
            } else {
                setCounter(counter - 1)
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [counter]);

    useEffect(() => {
        verifyLogin();
        let finalList = []
        jsonWithoutDialCode.map(val1 => {
            jsonWithDialCode.map(val2 => {
                if (val1.code === val2.code) {
                    finalList = [...finalList, { ...val1, ...val2 }]
                }
            })
        })
        setCountryList(finalList)
    }, []);

    const verifyLogin = () => {
        const isFromMobileApp = query.get("isFromMobileApp")
        console.log("123isFromMobileApp", isFromMobileApp)
        if (typeof window?.newsHuntAction != 'undefined' && typeof window?.newsHuntAction.isLoggedIn != 'undefined') {
            const isLoggedIn = window?.newsHuntAction?.isLoggedIn()
            localStorage.removeItem(REGISTER_DETAILS)
            if (!isLoggedIn) {
                localStorage.removeItem(REGISTER_DETAILS)
                dispatch(onJustReducerUpdate({}, PROFILE_DETAILS))
                // history.push("/")
                return
            }
            if (isLoggedIn) {
                if (window?.newsHuntAction) {
                    var getClientIdValue = ""
                    if (window?.newsHuntAction?.getClientId) {
                        getClientIdValue = window?.newsHuntAction?.getClientId()
                    }
                    var getUniqueAuthTokenValue = ""
                    if (window?.newsHuntAction?.getUniqueAuthToken) {
                        getUniqueAuthTokenValue = window?.newsHuntAction?.getUniqueAuthToken()
                    }
                    var getUserIdValue = ""
                    if (window?.newsHuntAction?.getUserId) {
                        getUserIdValue = window?.newsHuntAction?.getUserId()
                    }
                    let constructData = { ...authData, josh_client_id: getClientIdValue, token: getUniqueAuthTokenValue, josh_user_id: getUserIdValue, id: "" }
                    console.log("123construct", constructData)
                    localStorage.setItem(REGISTER_DETAILS, JSON.stringify(constructData))
                    getAppProfileInfo(getUserIdValue).then(res => {
                        console.log("123constructres", res)
                        localStorage.setItem(REGISTER_DETAILS, JSON.stringify(res.data))
                        history.push("/dashboards");
                        return
                    })
                }
            }
        }
        let authData = localStorage.getItem(REGISTER_DETAILS)
        authData = JSON.parse(authData)
        if (authData && Object.keys(authData)?.length !== 0) {
            history.push('/dashboards');
        }
    }

    useEffect(() => {
        if (otp.length === OTP_LENGTH) {
            const verifyPayload = {
                "client_id": client_id,
                "country_code": selectedCountry.dial_code,
                "mobile_no": phoneNumber,
                "otp": otp,
                "user_auth_type": "MOBILE"
            }
            onSendOTPVerify(verifyPayload).then((res) => {
                if (res.status) {
                    setIsError(false)
                    dispatch(onJustReducerUpdate(res.data, REGISTER_DETAILS))
                    localStorage.setItem(REGISTER_DETAILS, JSON.stringify(res.data))
                    toast.open("Login Successful")
                    $("#login-popup").modal("hide");
                    setTimeout(() => {
                        history.push("/dashboards");
                    }, 100)
                } else {
                    setIsError(true)
                    setIsResetEnable(true)
                }
            }).catch((err) => {
                setIsError(true)
                setIsResetEnable(true)
                console.log("123err ", err)
            })
        }
    }, [otp, client_id, dispatch, history, phoneNumber, selectedCountry.dial_code]);
    const onTriggerSendOTP = () => {
        const payload = {
            "client_id": client_id || clientIDs?.client_id || "",
            "country_code": selectedCountry.dial_code,
            "mobile_no": phoneNumber
        }
        if (phoneNumber) {
            onSendOTP(payload).then((response) => {
                setTriggerOtp(triggerOtp + 1)
                $(".login-wrap ").hide();
                $(".otp-wrap").show();
                setCounter(59)
                setIsOTPEnable(true)
                setOtpFocus(true)
            }).catch((error) => {
                console.log(error);
            });
        }
    }
    const openModal = () => {

        //  $("#country-popup").modal("show");
        $(".country-code-popup").css({ "opacity": "1", "display": "block" });
    };
    const onCountrySelect = (data) => {
        setSelectedCountry(data)
        setSearch("")
        // $("#country-popup").modal("hide");
        $(".country-code-popup").css({ "opacity": "0", "display": "none" });
    }
    const onLoginResolve = (provider, id_token, code_token = "") => {
        let payload = {
            "client_id": client_id || clientIDs?.client_id || "",
            "country_code": "",
            "mobile_no": "",
            "otp": "",
            "token": encryptResponse(id_token),
            "user_auth_type": provider?.toUpperCase(),
            "device_id": deviceId,
            "is_incognito": incognitoMode
        }
        if (provider?.toUpperCase() === "APPLE") {
            payload = { ...payload, authorizationCode: code_token }
        }
        onSocialVerify(payload).then((res) => {
            if (res.status) {
                if (payload?.user_auth_type === "GOOGLE") {
                    window?.google?.accounts?.id?.revoke(res?.data?.gid, done => {
                        console.log("revoke", done.error);
                    });
                }
                $("#aboutus-modal").modal("hide");
                dispatch(onJustReducerUpdate(res.data, REGISTER_DETAILS))
                localStorage.setItem(REGISTER_DETAILS, JSON.stringify(res.data))
                toast.open("Login Successful")
                $("#login-popup").modal("hide");
                history.push("/dashboards");
            }
        })
    }
    const onResend = () => {
        if (!isResetEnable) {
            return
        }
        otpRef.current.focusInput(1);
        setTimeout(() => otpRef.current.focusInput(0), 0);
        setIsError(false)
        onTriggerSendOTP()
        setIsResetEnable(false)
        setReSendClicked(true)
        setOtp("")
    }
    const onCountryClose = () => {
        setSearch("")
        // $("#country-popup").modal("hide");
        $(".country-code-popup").css({ "opacity": "0", "display": "none" });
    }
    const goBack = () => {
        $(".login-wrap ").show();
        $(".otp-wrap").hide();
        setReSendClicked(false)
        setIsError(false)
        setIsResetEnable(false)
    }
    const handleKeyPress = (e) => {
        if (e.keyCode === 13 && e.target.value != "") {
            onTriggerSendOTP()
        }
    }
    const OTPComponent = useCallback((props) => {
        const { otp, setOtp } = props
        const changeOTP = (val) => {
            setOtp(val);
        }
        return (
            <div className='otp-input-wrap'>
                <OtpInput className="input-fields"
                    ref={otpRef}
                    value={otp}
                    onChange={changeOTP}
                    numInputs={6}
                    isInputNum={true}
                    shouldAutoFocus
                />
            </div>)
    }, [otpFocus])
    return (
        <>
            <div className='creator-login'>
                {/* <div className='common-btn about-us-btn' data-toggle="modal" data-target="#aboutus-modal">
                    <button>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M6.3865 2.9165C4.279 2.9165 2.9165 4.36067 2.9165 6.5965V13.4032C2.9165 15.639 4.279 17.0832 6.3865 17.0832H13.6098C15.7198 17.0832 17.0832 15.639 17.0832 13.4032V6.5965C17.0832 4.36067 15.7198 2.9165 13.6115 2.9165H6.3865ZM13.6098 18.3332H6.3865C3.56317 18.3332 1.6665 16.3515 1.6665 13.4032V6.5965C1.6665 3.64817 3.56317 1.6665 6.3865 1.6665H13.6115C16.4357 1.6665 18.3332 3.64817 18.3332 6.5965V13.4032C18.3332 16.3515 16.4357 18.3332 13.6098 18.3332Z" fill="black" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M9.99463 13.9583C9.64963 13.9583 9.36963 13.6783 9.36963 13.3333V10C9.36963 9.655 9.64963 9.375 9.99463 9.375C10.3396 9.375 10.6196 9.655 10.6196 10V13.3333C10.6196 13.6783 10.3396 13.9583 9.99463 13.9583Z" fill="black" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M9.99912 7.67008C9.53829 7.67008 9.16162 7.29758 9.16162 6.83675C9.16162 6.37592 9.53079 6.00342 9.99079 6.00342H9.99912C10.46 6.00342 10.8325 6.37592 10.8325 6.83675C10.8325 7.29758 10.46 7.67008 9.99912 7.67008Z" fill="black" />
                        </svg>
                        <span>About Us</span></button>
                </div> */}
                <div className='login-form-wrap'>
                    <div className='form-details'>
                        <div className='login-wrap '>
                            <img src={joshLogo} alt="" />
                            <h2>Creator<span>PRO</span></h2>
                            <p>Access to social performance and <br />
                                monetization opportunities</p>
                            {/* <div className='form-group country-code-piker'>
                                <div className="country-select" onClick={openModal}>
                                    <img alt="down_arrow" src={selectedCountry.image}></img>
                                    <span>{selectedCountry.dial_code}<img className="down-arrow" src={down_arrow_gray} alt="" /></span>
                                </div>
                                <input className='form-control' onInput={(e) => e.target.value = e.target.value.slice(0, 15)} ref={myRef} onChange={(e) => setPhoneNumber(e.target.value)} placeholder='Enter your number' type="number" onKeyDown={handleKeyPress} />
                            </div>
                            <div className='common-btn'>
                                <button className={`sent-top ${phoneNumber && "send-otp-enable"}`} id="sent-top" onClick={() => onTriggerSendOTP()}>Send OTP</button>
                            </div>
                            <div className="or-login-with">
                                <span>OR</span>
                            </div> */}
                            <div className='social-btn-wrap'>
                                <div className='common-btn'>
                                    <GoogleLogin
                                        theme="filled_black"
                                        shape="circle"
                                        auto_select={false}
                                        onSuccess={(credentialResponse) => {
                                            console.log("123credentialResponse", credentialResponse);
                                            onLoginResolve("GOOGLE", credentialResponse?.credential)
                                        }}
                                        onError={() => {
                                            console.log('Login Failed');
                                        }}
                                    />
                                    {/* <div id="gSignInWrapper">
                                        <button id="customBtn"><img src={socialGoogle} alt="" /> <span>Google</span></button>
                                    </div> */}
                                    {/* <LoginSocialFacebook
                                        appId={process.env.REACT_APP_FB_APP_ID}
                                        fieldsProfile={
                                            'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
                                        }
                                        redirect_uri={REDIRECT_URI}
                                        onResolve={({ provider, data }) => {
                                            console.log("123provider, data ", provider, data)
                                            setProvider(provider)
                                            setProfile(data)
                                            onLoginResolve(provider, data?.accessToken)
                                        }}
                                        onReject={err => {
                                            console.log(err);
                                        }}
                                    >
                                        <button><img src={socialFacebook} alt="" /><span>Facebook</span></button>
                                    </LoginSocialFacebook> */}
                                    {/* <LoginSocialApple
                                        client_id={process.env.REACT_APP_APPLE_ID}
                                        scope={'email'}
                                        redirect_uri={REDIRECT_URI}
                                        onResolve={({ provider, data }) => {
                                            console.log("123provider, data ", provider, data)
                                            setProvider(provider)
                                            setProfile(data)
                                            onLoginResolve(provider, data?.authorization?.id_token, data.authorization.code)
                                        }}
                                        onReject={err => {
                                            console.log(err);
                                        }}
                                    >
                                        <button><img src={socialApple} alt="" /><span>Apple</span></button>
                                    </LoginSocialApple> */}
                                </div>
                            </div>
                        </div>
                        {/* <div className='otp-wrap'>
                            <img id='back-login' onClick={goBack} className='back-btn cursor-pointer' src={backImg} alt="" />
                            <h2>Verify OTP</h2>
                            <p>Please enter the OTP sent to <br />
                                {selectedCountry.dial_code} {phoneNumberFormat(phoneNumber)}</p>
                            <OTPComponent otp={otp} setOtp={setOtp} />
                            <div className="resend-otp-wrap">
                                {isError ?
                                    <span>The OTP entered is invaild/incorrect. Please try again</span> :
                                    reSendClicked ? <span>A new OTP has been sent. {counter != 0 ? `00:${counter.toLocaleString('en-US', { minimumIntegerDigits: 2 })}s` : ""}</span> :
                                        <span>Didn't receive OTP? {counter != 0 ? `Please wait for 00:${counter.toLocaleString('en-US', { minimumIntegerDigits: 2 })}s` : ""}</span>
                                }
                                <a className={(isError || isResetEnable) && "isError"} onClick={onResend}>Resend code</a>
                            </div>
                        </div> */}
                        <div className='terms-content'>
                            By signing up you agree with  <span><a href="https://share.myjosh.in/terms-conditions" target="_blank">Terms of Use</a> & <a href="https://share.myjosh.in/privacy" target="_blank">
                                Privacy Policy</a></span>
                        </div>
                        {/* <div id="appleid-signin" data-color="black" data-border="true" data-type="sign in"></div> */}
                        {/* <div
                            className="modal fade country-code-popup"
                            id="country-popup"
                            tabIndex="-1"
                            role="dialog"
                            aria-labelledby="exampleModalLabel"
                            data-backdrop="static" data-keyboard="false"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-dialog-centered  custom-popup country-picker-modal" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title w-auto" id="exampleModalLabel">
                                            Select your country
                                        </h5>
                                        <button type="button" onClick={onCountryClose} className="close country-close">
                                            <span aria-hidden="true">
                                                <img src={CloseDarkBlack} alt="" />
                                            </span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="searchFilter">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Country Name"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                        </div>
                                        <div className="country-list popup-scroll p-0">
                                            {countryList
                                                .filter((value) => {
                                                    if (search === "") {
                                                        return value;
                                                    } else if (
                                                        value.name
                                                            .toLowerCase()
                                                            .includes(search.toLowerCase())
                                                    ) {
                                                        return value;
                                                    }
                                                })
                                                .map((value, key) => {
                                                    return (
                                                        <div
                                                            className="list"
                                                            key={key}
                                                            onClick={() => onCountrySelect(value)}
                                                        >
                                                            <img src={value.image} alt="" />
                                                            {value.name}
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>

                </div>
                {/* {incognito && <>
                    <div className="cookiesEnable"><img src={Toast_Icon} alt="" /> <span className="cookiesText">Please enable cookies in incognito mode</span> </div> </>} */}
            </div>

            {/* About Us Popup HTML Start Here  */}
            {/* <div
                className="modal fade about-us-overlay"
                id="aboutus-modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                // data-backdrop="static" data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup aboutus-popup" role="document">
                    <div className="modal-content   ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                About Us
                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span aria-hidden="true">
                                    <img src={Close_white} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="aboutus-content">
                                        <div className="coin-right"><img src={leftCoin} alt="" /></div>
                                        <div className="coin-left "><img src={rightCoin} alt="" /></div>
                                        <p>How do I earn money using my social accounts? </p>
                                        <span>CreatorPro is the solution. Link your social accounts and get access to exciting monetization opportunities.</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="about-OwlCarousel">
                                        <OwlCarousel
                                            className="owl-theme"
                                            loop={true}
                                            margin={20}
                                            nav={false}
                                            autoWidth={false}
                                            autoplay={true}
                                            responsive={{
                                                0: {
                                                    items: 1,
                                                    stagePadding: 0,
                                                },
                                                600: {
                                                    items: 1,
                                                    stagePadding: 30,
                                                },
                                                1000: {
                                                    items: 1,
                                                },
                                            }}
                                        >
                                            <div className="item">
                                                <div className="aboutus-slider-wrap">
                                                    <div className="aboutus-slider-card">
                                                        <img src={aboutSlider1} alt="" />
                                                        <p>45+ performance metrics tracked in one place </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item">
                                                <div className="aboutus-slider-wrap">
                                                    <div className="aboutus-slider-card">
                                                        <img src={aboutSlider2} alt="" />
                                                        <p>10000+ brands are waiting for colloborations </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item">
                                                <div className="aboutus-slider-wrap">
                                                    <div className="aboutus-slider-card">
                                                        <img src={aboutSlider3} alt="" />
                                                        <p>Connect more accounts and monitor your performance</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item">
                                                <div className="aboutus-slider-wrap">
                                                    <div className="aboutus-slider-card">
                                                        <img src={aboutSlider4} alt="" />
                                                        <p>Choose from 20000+ affiliate products</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </OwlCarousel>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="footer-text">
                                Join 10,000+ creators who are using Creator PRO now!
                                <div className="login-otp-wrap">
                                    <div className="common-btn">
                                        <button onClick={handleFocus} data-dismiss="modal">Login with OTP</button>
                                    </div>
                                    <div className="or-class"> <span>OR</span> </div>
                                    <ul>
                                        <li>
                                            <img className="cursor-pointer" id="googleBtn" src={aboutIocon2} alt="" />
                                        </li>
                                        <li>
                                            <LoginSocialFacebook
                                                appId={process.env.REACT_APP_FB_APP_ID}
                                                fieldsProfile={
                                                    'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
                                                }
                                                redirect_uri={REDIRECT_URI}
                                                onResolve={({ provider, data }) => {
                                                    console.log("123provider, data ", provider, data)
                                                    setProvider(provider)
                                                    setProfile(data)
                                                    onLoginResolve(provider, data?.accessToken)
                                                }}
                                                onReject={err => {
                                                    console.log(err);
                                                }}
                                            >
                                                <img className="cursor-pointer" src={aboutIocon3} alt="" />
                                            </LoginSocialFacebook>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* About Us Popup HTML Start Here  */}
        </>
    )
}

export default IsLoadingHOC(Login)